// logo shrink

// Helper: total top offset = static announcement bar + scrolling bar
function hpTotalBarHeight() {
  var staticBar = document.querySelector('.main-announcement-bar');
  var scrollingBar = document.querySelector('.scrolling-announcement-bar-section');
  var staticH = staticBar ? staticBar.offsetHeight : 0;
  var scrollingH = scrollingBar ? scrollingBar.offsetHeight : 0;
  return staticH + scrollingH;
}

if(__st.p == 'home' || __st.pageurl.includes('/404')){
  window.addEventListener('scroll', (e)=>{
    let scrollCount = window.pageYOffset;
    let logoHeight = parseInt(document.querySelector('.desk-logo').getAttribute('data-max'));
    let logoMinHeight = parseInt(document.querySelector('.desk-logo').getAttribute('data-min'));
    if(window.innerWidth > 1440){
      logoHeight = parseInt(document.querySelector('.desk-logo').getAttribute('data-max'));
    }else if(window.innerWidth > 1199){
      logoHeight = 118;
    }else if(window.innerWidth > 991){
      logoHeight = 75;
    }else if(window.innerWidth > 575){
      logoHeight = 85;
    }else if(window.innerWidth > 374){
      logoHeight = 52;
    }else{
      logoHeight = 40;
    }
    if(window.innerWidth < 992 && window.innerWidth > 374){
      logoMinHeight = 41;
    }else if(window.innerWidth < 375){
      logoMinHeight = 34;
    }
    if(scrollCount <= (logoHeight * 3)){
      logoHeight = logoHeight - (scrollCount / 3);
      document.querySelector('header').classList.remove('sticky-header');
      if(logoMinHeight <= logoHeight){
        document.querySelector('.logo svg').style.height = logoHeight+'px';
        document.querySelector('header').classList.remove('sticky-header');
        let mainTop = hpTotalBarHeight() - scrollCount;
        if(mainTop >= 0){
          document.querySelector('.header-main').style.top = mainTop+'px';
        }else{
          document.querySelector('.header-main').style.top = '0px';
        }
      }else{
        document.querySelector('header').classList.add('sticky-header');
        document.querySelector('.logo svg').style.height = logoMinHeight+'px';
      }
    }else{
      document.querySelector('header').classList.add('sticky-header');
      document.querySelector('.logo svg').style.height = logoMinHeight+'px';
      document.querySelector('.header-main').style.top = '0px';
    }
  });
}else{
  let original_header = document.querySelector('.header-main').offsetHeight;
  window.addEventListener('scroll', (e)=>{
    let scrollCount = window.pageYOffset;
    let logoHeight = parseInt(document.querySelector('.desk-logo').getAttribute('data-max'));
    let logoMinHeight = parseInt(document.querySelector('.desk-logo').getAttribute('data-min'));
    if(window.innerWidth > 991){
      logoHeight = parseInt(document.querySelector('.desk-logo').getAttribute('data-max'));
    }else if(window.innerWidth > 575){
      logoHeight = 69;
    }else if(window.innerWidth > 374){
      logoHeight = 61;
    }else{
      logoHeight = 50;
    }
    if(window.innerWidth < 992 && window.innerWidth > 374){
      logoMinHeight = 41;
    }else if(window.innerWidth < 375){
      logoMinHeight = 34;
    }
    var header = document.querySelector('.header-main').offsetHeight;
    if(scrollCount > 100){
      document.querySelector('main').style.marginTop = header+'px';
    }else{
      document.querySelector('main').style.marginTop = original_header+'px';
    }
    if(scrollCount <= (logoHeight * 3)){
      logoHeight = logoHeight - (scrollCount / 3);
      document.querySelector('header').classList.remove('sticky-header');
      if(logoMinHeight <= logoHeight){
        document.querySelector('.logo svg').style.height = logoHeight+'px';
        document.querySelector('header').classList.remove('sticky-header');
        let mainTop = hpTotalBarHeight() - scrollCount;
        if(mainTop >= 0){
          document.querySelector('.header-main').style.top = mainTop+'px';
        }else{
          document.querySelector('.header-main').style.top = '0px';
        }
      }else{
        let mainTop = hpTotalBarHeight() - scrollCount;
        if(mainTop >= 0){
          document.querySelector('.header-main').style.top = mainTop+'px';
        }else{
          document.querySelector('.header-main').style.top = '0px';
        }
        document.querySelector('header').classList.add('sticky-header');
        document.querySelector('.logo svg').style.height = logoMinHeight+'px';
      }
    }else{
      document.querySelector('header').classList.add('sticky-header');
      document.querySelector('.logo svg').style.height = logoMinHeight+'px';
      document.querySelector('.header-main').style.top = '0px';
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  document.querySelector('.header-main').style.top = hpTotalBarHeight()+'px';
  var scrollCount = window.pageYOffset;
  if(scrollCount > 100){
    document.querySelector('.logo svg').style.height = '43px'
  }
  document.querySelector('.menu-burger').addEventListener('click',function(e){
    e.preventDefault();
    document.body.classList.add('menu-open')
  });
  document.querySelector('.menu-drawer-close').addEventListener('click',function(e){
    e.preventDefault();
    document.body.classList.remove('menu-open')
  });
  const menus = document.querySelectorAll(".mainlink");
  menus.forEach((menu) => {
    menu.addEventListener("click", () => {
      if(menu.parentNode.classList.contains("active")){
        menu.parentNode.classList.remove("active");
      }else{
        const menusOpen = document.querySelectorAll(".mega-list .active");
        menusOpen.forEach((menuOpen) => {
          menuOpen.classList.remove("active");
        });
        menu.parentNode.classList.add("active");
      }
    });
  });
});
document.querySelectorAll('header a').forEach((all_anchor) => {
   all_anchor.addEventListener("click", () => {
     localStorage.removeItem("content-with-media");
   })
})